import { Container, Box, Divider, Body } from '@hover/blueprint';
import React, { useState, useRef } from 'react';
import Slider from 'react-slick';
import { BETTER_WAY_TO_BUILD_CAROUSEL_DATA } from '../../../constants';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const PAGES_NUMBER = Array.from(Array(6).keys());

const setting = {
  dots: false,
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
};

const BetterWayMobile: React.FC = () => {
  const [selectedTab, setSelectedTab] = useState<number>(0);
  const sliderRef = useRef<Slider>(null);

  const onSelectItem = (tabNumber: number) => {
    setSelectedTab(tabNumber);
    sliderRef?.current?.slickGoTo(tabNumber);
  };

  return (
    <Container d={{ base: 'block', desktop: 'none' }}>
      <Box justifyContent="space-between" position="relative">
        <Divider position="absolute" color="neutral.100" top="16px" my={0} />
        {PAGES_NUMBER.map(item => (
          <Box
            cursor="pointer"
            onClick={() => onSelectItem(item)}
            zIndex={10}
            key={item}
            w={300}
            h={300}
            borderRadius="50%"
            bg={selectedTab === item ? 'brandNavy.100' : 'neutral.100'}
            color={selectedTab === item ? 'black' : 'neutral.500'}
            alignItems="center"
            justifyContent="center"
          >
            {item + 1}
          </Box>
        ))}
      </Box>
      <Slider ref={sliderRef} {...setting} afterChange={setSelectedTab}>
        {BETTER_WAY_TO_BUILD_CAROUSEL_DATA.map(carouselItem => (
          <Box
            flexDir="column"
            w="100%"
            d="flex !important"
            mt="56px"
            alignItems="center"
            key={carouselItem.index}
          >
            {carouselItem.img}
            <Body mt={600} size={600} isSemiBold textAlign="center">
              {carouselItem.body}
            </Body>
          </Box>
        ))}
      </Slider>
    </Container>
  );
};

export default BetterWayMobile;
